import * as Yup from 'yup'

const accessLevelValidator = Yup.object ({
  name: Yup.string ().required ('Digite um nome'),
  description: Yup.string ()
    .required ('Digite uma descrição')
    .max (128, 'A descrição conter até 128 caracteres')
})

export default accessLevelValidator
